// extracted by mini-css-extract-plugin
module.exports = {"container":"LabelInput_container__2AKpY","label":"LabelInput_label__24tSY"};